import React, { useEffect, useRef } from 'react';
import { CheckIcon, ClockIcon, SparklesIcon, UtensilsIcon, ShieldCheckIcon, ZapIcon, StarIcon, ChevronDownIcon, ArrowRightIcon, XCircleIcon, BookOpenIcon, FlameIcon, ShoppingBagIcon, HeartIcon, TimerIcon, BadgeCheckIcon } from 'lucide-react';
const HOTMART_LINK = 'https://pay.hotmart.com/Q104980790O';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/qR2NBCDKBWrR2yodD7A6hu/PORTADA_ARFRER.png';
function fireAddToCart() {
  try {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart');
    }
  } catch (e) {
    // pixel not loaded
  }
}
function CTAButton({
  text,
  className = '',
  mode = 'scroll'
}: {
  text?: string;
  className?: string;
  mode?: 'scroll' | 'checkout';
}) {
  const handleClick = () => {
    if (mode === 'checkout') {
      fireAddToCart();
      window.open(HOTMART_LINK, '_blank');
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 bg-[#2DB742] hover:bg-[#25A038] text-white font-bold text-lg px-8 py-4 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl ${className}`} aria-label="Quero o Protocolo Airfryer - Comprar agora" data-id="element-23">
      <ShoppingBagIcon className="w-5 h-5" aria-hidden="true" data-id="element-24" />
      <span data-id="element-25">{text || 'QUERO O PROTOCOLO'}</span>
      <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-26" />
    </button>;
}
function SectionDivider() {
  return <div className="flex items-center justify-center py-2" data-id="element-27">
      <div className="w-16 h-0.5 bg-[#C8A951]/30 rounded-full" data-id="element-28" />
    </div>;
}
function StarRating() {
  return <div className="flex gap-0.5" aria-label="5 estrelas" data-id="element-29">
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-30" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-31" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-32" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-33" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-34" />
    </div>;
}
export function SalesPage() {
  const pricingRef = useRef<HTMLDivElement>(null);
  return <main className="w-full" data-id="element-35">
      {/* ===== HERO SECTION ===== */}
      <section className="bg-[#FFF8F0] py-16 md:py-24 px-4" data-id="element-36">
        <div className="max-w-5xl mx-auto" data-id="element-37">
          <div className="flex flex-col items-center text-center" data-id="element-38">
            <div className="inline-flex items-center gap-2 bg-[#C8A951]/15 text-[#A68A3E] text-sm font-semibold px-3 py-1.5 rounded-full mb-6" data-id="element-39">
              <FlameIcon className="w-4 h-4" aria-hidden="true" data-id="element-40" />
              <span data-id="element-41">Método exclusivo para brasileiras</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight mb-3" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-42">
              Protocolo Airfryer Premium:
            </h1>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight mb-6" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-43">
              <span className="text-[#C8A951]" data-id="element-44">
                Jantar Saudável em 15 Minutos
              </span>{' '}
              <span className="text-[#1a1a1a]" data-id="element-45">(Sem Sujar a Cozinha)</span>
            </h2>
            <p className="text-lg md:text-xl text-[#5a5a5a] leading-relaxed mb-8 max-w-2xl" style={{
            fontFamily: "'DM Sans', sans-serif"
          }} data-id="element-46">
              O método "Clean-Basket" para mulheres cansadas que querem comer
              bem sem gastar com delivery nem lavar montanhas de louça.
            </p>

            <div className="relative mb-8" data-id="element-47">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#C8A951]/20 to-transparent rounded-3xl blur-2xl" data-id="element-48" />
              <img src={PRODUCT_IMAGE} alt="Protocolo Airfryer Premium - Guia digital com receitas saudáveis para Airfryer" className="relative w-72 md:w-80 lg:w-96 rounded-2xl shadow-2xl" data-id="element-49" />
            </div>

            <CTAButton text="QUERO O PROTOCOLO" mode="scroll" className="w-full sm:w-auto" data-id="element-50" />
            <p className="mt-4 text-xs text-[#5a5a5a] flex items-center gap-1.5" data-id="element-51">
              <ShieldCheckIcon className="w-4 h-4 text-green-600" aria-hidden="true" data-id="element-52" />
              Compra 100% segura via Hotmart · Acesso imediato
            </p>
          </div>
        </div>
      </section>

      {/* ===== OPENING HOOK ===== */}
      <section className="bg-white py-16 md:py-20 px-4" data-id="element-53">
        <div className="max-w-3xl mx-auto" data-id="element-54">
          <div className="bg-[#FFF8F0] rounded-2xl p-8 md:p-12 border border-[#C8A951]/20" data-id="element-55">
            <div className="flex items-center gap-2 mb-6" data-id="element-56">
              <ClockIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-57" />
              <span className="text-sm font-semibold text-[#C8A951] uppercase tracking-wide" data-id="element-58">
                19h15 — Sua realidade
              </span>
            </div>
            <p className="text-lg md:text-xl text-[#1a1a1a] leading-relaxed mb-6" style={{
            fontFamily: "'DM Sans', sans-serif"
          }} data-id="element-59">
              São 19h15. Você acabou de chegar em casa. Seus pés doem, sua mente
              está exausta e a última coisa que você quer é passar uma hora na
              frente do fogão.
            </p>
            <p className="text-lg md:text-xl text-[#1a1a1a] leading-relaxed" data-id="element-60">
              Você abre a geladeira, encara o que tem dentro e sente aquela
              vontade irresistível de pegar o celular e gastar{' '}
              <strong className="text-[#E53E3E]" data-id="element-61">R$ 60,00</strong> em um iFood
              que só vai chegar daqui a 50 minutos.
            </p>
          </div>
        </div>
      </section>

      {/* ===== THE PROBLEM ===== */}
      <section className="bg-[#0a0a0a] py-16 md:py-20 px-4 text-white" data-id="element-62">
        <div className="max-w-3xl mx-auto" data-id="element-63">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-64">
            O ciclo que <span className="text-[#E53E3E]" data-id="element-65">esgota</span> sua
            energia e seu bolso
          </h2>
          <p className="text-lg text-white/80 leading-relaxed mb-8 text-center" style={{
          fontFamily: "'DM Sans', sans-serif"
        }} data-id="element-66">
            A maioria das mulheres vive nesse ciclo: ou come mal (comida
            congelada e delivery caro) ou gasta o pouco tempo de descanso que
            tem esfregando panelas e picando vegetais.
          </p>
          <div className="bg-white/5 rounded-2xl p-8 border border-white/10" data-id="element-67">
            <p className="text-white/90 leading-relaxed text-lg" data-id="element-68">
              Você comprou a Airfryer achando que seria a solução, mas ela
              acabou virando um{' '}
              <strong className="text-[#C8A951]" data-id="element-69">
                "forno de batata frita"
              </strong>{' '}
              encostado no canto da cozinha. Quando tenta usar, a comida fica
              seca, o frango fica murcho e a cesta fica tão grudada de gordura
              que você desiste de usar no dia seguinte só para não ter que
              lavar.
            </p>
          </div>
        </div>
      </section>

      {/* ===== WHY OTHER SOLUTIONS FAILED ===== */}
      <section className="bg-[#FFF8F0] py-16 md:py-20 px-4" data-id="element-70">
        <div className="max-w-3xl mx-auto" data-id="element-71">
          <h2 className="text-2xl md:text-3xl font-bold mb-10 text-center text-[#1a1a1a]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-72">
            Por que o que você já tentou{' '}
            <span className="text-[#E53E3E]" data-id="element-73">não funcionou</span>
          </h2>
          <div className="space-y-5" data-id="element-74">
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-gray-100" data-id="element-75">
              <XCircleIcon className="w-6 h-6 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-76" />
              <p className="text-[#1a1a1a]" data-id="element-77">
                <strong data-id="element-78">Livros de receitas tradicionais</strong> pedem
                ingredientes exóticos que você não tem na despensa média
                brasileira.
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-gray-100" data-id="element-79">
              <XCircleIcon className="w-6 h-6 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-80" />
              <p className="text-[#1a1a1a]" data-id="element-81">
                <strong data-id="element-82">Receitas de internet</strong> focam em "parecer bonito",
                mas ignoram os 20 minutos que você leva limpando a máquina
                depois.
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-gray-100" data-id="element-83">
              <XCircleIcon className="w-6 h-6 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-84" />
              <p className="text-[#1a1a1a]" data-id="element-85">
                <strong data-id="element-86">O "Meal Prep" de domingo</strong> parece ótimo, até você
                perceber que perdeu seu único dia de folga cozinhando para a
                semana toda.
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-gray-100" data-id="element-87">
              <XCircleIcon className="w-6 h-6 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-88" />
              <p className="text-[#1a1a1a]" data-id="element-89">
                <strong data-id="element-90">Usar a Airfryer como forno comum</strong> não funciona —
                a física do ar quente é diferente e exige uma técnica específica
                para não ressecar a comida.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== UNIQUE MECHANISM ===== */}
      <section className="bg-white py-16 md:py-20 px-4" data-id="element-91">
        <div className="max-w-3xl mx-auto text-center" data-id="element-92">
          <div className="inline-flex items-center gap-2 bg-[#C8A951]/15 text-[#A68A3E] text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-93">
            <SparklesIcon className="w-4 h-4" aria-hidden="true" data-id="element-94" />
            <span data-id="element-95">A solução definitiva</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-[#1a1a1a] mb-8" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-96">
            Método <span className="text-[#C8A951]" data-id="element-97">Clean-Basket 15</span>
          </h2>
          <p className="text-lg text-[#5a5a5a] leading-relaxed mb-8" data-id="element-98">
            Não é apenas um livro de receitas. É um{' '}
            <strong className="text-[#1a1a1a]" data-id="element-99">
              sistema de fluxo único (One-Basket Flow)
            </strong>{' '}
            focado em três pilares:
          </p>
          <div className="grid sm:grid-cols-3 gap-6 mb-10" data-id="element-100">
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C8A951]/15" data-id="element-101">
              <div className="w-12 h-12 rounded-full bg-[#C8A951]/15 flex items-center justify-center mx-auto mb-4" data-id="element-102">
                <TimerIcon className="w-6 h-6 text-[#C8A951]" aria-hidden="true" data-id="element-103" />
              </div>
              <h3 className="font-bold text-[#1a1a1a] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-104">
                Preparo Zero
              </h3>
              <p className="text-sm text-[#5a5a5a]" data-id="element-105">
                Tempo de preparo praticamente eliminado com técnicas
                inteligentes
              </p>
            </div>
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C8A951]/15" data-id="element-106">
              <div className="w-12 h-12 rounded-full bg-[#C8A951]/15 flex items-center justify-center mx-auto mb-4" data-id="element-107">
                <UtensilsIcon className="w-6 h-6 text-[#C8A951]" aria-hidden="true" data-id="element-108" />
              </div>
              <h3 className="font-bold text-[#1a1a1a] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-109">
                Camadas Inteligentes
              </h3>
              <p className="text-sm text-[#5a5a5a]" data-id="element-110">
                Proteína e acompanhamento juntos — o suco da carne tempera os
                legumes
              </p>
            </div>
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C8A951]/15" data-id="element-111">
              <div className="w-12 h-12 rounded-full bg-[#C8A951]/15 flex items-center justify-center mx-auto mb-4" data-id="element-112">
                <ShieldCheckIcon className="w-6 h-6 text-[#C8A951]" aria-hidden="true" data-id="element-113" />
              </div>
              <h3 className="font-bold text-[#1a1a1a] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-114">
                Proteção Anti-Sujeira
              </h3>
              <p className="text-sm text-[#5a5a5a]" data-id="element-115">
                Protege o teflon e a limpeza é apenas um enxágue rápido
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHAT YOU GET ===== */}
      <section className="bg-[#0a0a0a] py-16 md:py-20 px-4 text-white" data-id="element-116">
        <div className="max-w-3xl mx-auto" data-id="element-117">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-118">
            O que você <span className="text-[#C8A951]" data-id="element-119">recebe</span> hoje
          </h2>
          <p className="text-white/60 text-center mb-10" data-id="element-120">
            Tudo o que você precisa para transformar suas noites
          </p>

          <div className="space-y-4" data-id="element-121">
            <div className="flex items-start gap-4 bg-white/5 rounded-xl p-5 border border-white/10" data-id="element-122">
              <div className="w-10 h-10 rounded-lg bg-[#C8A951]/20 flex items-center justify-center flex-shrink-0" data-id="element-123">
                <BookOpenIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-124" />
              </div>
              <div data-id="element-125">
                <h3 className="font-bold text-white mb-1" data-id="element-126">
                  O Guia Protocolo Airfryer Premium (PDF)
                </h3>
                <p className="text-white/70 text-sm" data-id="element-127">
                  O passo a passo do método 5-2-5 para carnes suculentas.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/5 rounded-xl p-5 border border-white/10" data-id="element-128">
              <div className="w-10 h-10 rounded-lg bg-[#C8A951]/20 flex items-center justify-center flex-shrink-0" data-id="element-129">
                <SparklesIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-130" />
              </div>
              <div data-id="element-131">
                <h3 className="font-bold text-white mb-1" data-id="element-132">
                  Técnica Anti-Sujeira
                </h3>
                <p className="text-white/70 text-sm" data-id="element-133">
                  O segredo para nunca mais precisar esfregar a cesta da
                  Airfryer.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/5 rounded-xl p-5 border border-white/10" data-id="element-134">
              <div className="w-10 h-10 rounded-lg bg-[#C8A951]/20 flex items-center justify-center flex-shrink-0" data-id="element-135">
                <ClockIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-136" />
              </div>
              <div data-id="element-137">
                <h3 className="font-bold text-white mb-1" data-id="element-138">
                  Cardápio de Emergência das 19h
                </h3>
                <p className="text-white/70 text-sm" data-id="element-139">
                  Receitas de uma página com ingredientes que você já tem em
                  casa.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/5 rounded-xl p-5 border border-white/10" data-id="element-140">
              <div className="w-10 h-10 rounded-lg bg-[#C8A951]/20 flex items-center justify-center flex-shrink-0" data-id="element-141">
                <ZapIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-142" />
              </div>
              <div data-id="element-143">
                <h3 className="font-bold text-white mb-1" data-id="element-144">
                  Tabela de Conversão Turbo
                </h3>
                <p className="text-white/70 text-sm" data-id="element-145">
                  Como transformar qualquer receita de forno ou fogão em uma
                  versão Airfryer 3x mais rápida.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-gradient-to-r from-[#C8A951]/10 to-transparent rounded-xl p-5 border border-[#C8A951]/30" data-id="element-146">
              <div className="w-10 h-10 rounded-lg bg-[#C8A951]/30 flex items-center justify-center flex-shrink-0" data-id="element-147">
                <StarIcon className="w-5 h-5 text-[#C8A951]" aria-hidden="true" data-id="element-148" />
              </div>
              <div data-id="element-149">
                <div className="inline-block bg-[#C8A951] text-[#0a0a0a] text-xs font-bold px-2 py-0.5 rounded mb-2" data-id="element-150">
                  BÔNUS
                </div>
                <h3 className="font-bold text-white mb-1" data-id="element-151">
                  Guia "Airfryer no Café da Manhã" + Checklist de Compra
                  Inteligente
                </h3>
                <p className="text-white/70 text-sm" data-id="element-152">
                  Receitas matinais e uma lista de compras otimizada em 10
                  minutos.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-153">
            <CTAButton text="QUERO O PROTOCOLO" data-id="element-154" />
          </div>
        </div>
      </section>

      {/* ===== WHO THIS IS FOR / NOT FOR ===== */}
      <section className="bg-[#FFF8F0] py-16 md:py-20 px-4" data-id="element-155">
        <div className="max-w-4xl mx-auto" data-id="element-156">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-157">
            {/* For */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-green-100" data-id="element-158">
              <div className="flex items-center gap-2 mb-6" data-id="element-159">
                <CheckIcon className="w-6 h-6 text-green-600" aria-hidden="true" data-id="element-160" />
                <h2 className="text-xl font-bold text-[#1a1a1a]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-161">
                  Isso é para você se...
                </h2>
              </div>
              <ul className="space-y-4" data-id="element-162">
                <li className="flex items-start gap-3" data-id="element-163">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-164" />
                  <span className="text-[#1a1a1a]" data-id="element-165">
                    Trabalha fora e chega em casa exausta, mas não abre mão da
                    saúde.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-166">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-167" />
                  <span className="text-[#1a1a1a]" data-id="element-168">
                    É mãe e precisa de soluções rápidas para nutrir a família
                    sem sujar a cozinha toda.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-169">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-170" />
                  <span className="text-[#1a1a1a]" data-id="element-171">
                    Mora sozinha e odeia o desperdício de ligar um forno grande
                    para apenas uma pessoa.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-172">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-173" />
                  <span className="text-[#1a1a1a]" data-id="element-174">
                    É iniciante na cozinha e quer resultados de "chef" com o
                    apertar de um botão.
                  </span>
                </li>
              </ul>
            </div>

            {/* Not For */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-red-100" data-id="element-175">
              <div className="flex items-center gap-2 mb-6" data-id="element-176">
                <XCircleIcon className="w-6 h-6 text-[#E53E3E]" aria-hidden="true" data-id="element-177" />
                <h2 className="text-xl font-bold text-[#1a1a1a]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-178">
                  Isso NÃO é para você se...
                </h2>
              </div>
              <ul className="space-y-4" data-id="element-179">
                <li className="flex items-start gap-3" data-id="element-180">
                  <XCircleIcon className="w-5 h-5 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-181" />
                  <span className="text-[#1a1a1a]" data-id="element-182">
                    Tem tempo de sobra para passar 2 horas cozinhando e
                    limpando.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-183">
                  <XCircleIcon className="w-5 h-5 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-184" />
                  <span className="text-[#1a1a1a]" data-id="element-185">
                    Busca receitas gourmet complexas com ingredientes caros e
                    difíceis de achar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-186">
                  <XCircleIcon className="w-5 h-5 text-[#E53E3E] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-187" />
                  <span className="text-[#1a1a1a]" data-id="element-188">
                    Não possui (e não pretende ter) uma Airfryer em casa.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS ===== */}
      <section className="bg-white py-16 md:py-20 px-4" data-id="element-189">
        <div className="max-w-3xl mx-auto" data-id="element-190">
          <h2 className="text-2xl md:text-3xl font-bold mb-12 text-center text-[#1a1a1a]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-191">
            Como funciona em{' '}
            <span className="text-[#C8A951]" data-id="element-192">3 passos simples</span>
          </h2>
          <div className="space-y-8" data-id="element-193">
            <div className="flex items-start gap-5" data-id="element-194">
              <div className="w-12 h-12 rounded-full bg-[#C8A951] flex items-center justify-center flex-shrink-0 text-white font-bold text-lg" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-195">
                1
              </div>
              <div data-id="element-196">
                <h3 className="text-lg font-bold text-[#1a1a1a] mb-2" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-197">
                  Escolha uma proteína e um vegetal
                </h3>
                <p className="text-[#5a5a5a]" data-id="element-198">
                  Siga o nosso guia de combinações inteligentes — sem
                  complicação.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5" data-id="element-199">
              <div className="w-12 h-12 rounded-full bg-[#C8A951] flex items-center justify-center flex-shrink-0 text-white font-bold text-lg" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-200">
                2
              </div>
              <div data-id="element-201">
                <h3 className="text-lg font-bold text-[#1a1a1a] mb-2" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-202">
                  Aplique a Técnica de Camadas
                </h3>
                <p className="text-[#5a5a5a]" data-id="element-203">
                  Coloque tudo na cesta seguindo o mapa de calor do Protocolo.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-5" data-id="element-204">
              <div className="w-12 h-12 rounded-full bg-[#C8A951] flex items-center justify-center flex-shrink-0 text-white font-bold text-lg" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-205">
                3
              </div>
              <div data-id="element-206">
                <h3 className="text-lg font-bold text-[#1a1a1a] mb-2" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-207">
                  Aperte o Play e Descanse
                </h3>
                <p className="text-[#5a5a5a]" data-id="element-208">
                  Vá tomar um banho ou relaxar. Em 15 minutos, seu jantar está
                  pronto e a louça é mínima.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className="bg-[#FFF8F0] py-16 md:py-20 px-4" data-id="element-209">
        <div className="max-w-4xl mx-auto" data-id="element-210">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center text-[#1a1a1a]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-211">
            O que nossas <span className="text-[#C8A951]" data-id="element-212">clientes</span> dizem
          </h2>
          <p className="text-[#5a5a5a] text-center mb-10" data-id="element-213">
            Resultados reais de mulheres brasileiras como você
          </p>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-214">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-215">
              <StarRating data-id="element-216" />
              <p className="text-[#1a1a1a] mt-4 mb-5 leading-relaxed" data-id="element-217">
                "Gente, eu não acreditava que ia funcionar! Chego morta do
                trabalho e agora em 15 minutos tenho um jantar incrível. Meu
                marido até parou de pedir delivery.{' '}
                <strong data-id="element-218">Economizamos quase R$ 200 no primeiro mês!</strong>"
              </p>
              <div className="flex items-center gap-3" data-id="element-219">
                <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face" alt="Foto de Carla Mendes" className="w-10 h-10 rounded-full object-cover" data-id="element-220" />
                <div data-id="element-221">
                  <p className="font-semibold text-sm text-[#1a1a1a]" data-id="element-222">
                    Carla Mendes
                  </p>
                  <p className="text-xs text-[#5a5a5a]" data-id="element-223">São Paulo, SP</p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-224">
              <StarRating data-id="element-225" />
              <p className="text-[#1a1a1a] mt-4 mb-5 leading-relaxed" data-id="element-226">
                "Sou mãe de dois e não tinha tempo pra nada. A técnica de
                camadas é genial — coloco frango e legumes juntos e fica tudo
                temperado naturalmente. <strong data-id="element-227">Meus filhos adoram!</strong>"
              </p>
              <div className="flex items-center gap-3" data-id="element-228">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face" alt="Foto de Fernanda Oliveira" className="w-10 h-10 rounded-full object-cover" data-id="element-229" />
                <div data-id="element-230">
                  <p className="font-semibold text-sm text-[#1a1a1a]" data-id="element-231">
                    Fernanda Oliveira
                  </p>
                  <p className="text-xs text-[#5a5a5a]" data-id="element-232">Belo Horizonte, MG</p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-233">
              <StarRating data-id="element-234" />
              <p className="text-[#1a1a1a] mt-4 mb-5 leading-relaxed" data-id="element-235">
                "A parte anti-sujeira mudou minha vida. Antes eu odiava lavar a
                cesta grudenta. Agora é só um enxágue rápido e pronto.{' '}
                <strong data-id="element-236">Uso a Airfryer todo dia sem reclamar!</strong>"
              </p>
              <div className="flex items-center gap-3" data-id="element-237">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face" alt="Foto de Juliana Costa" className="w-10 h-10 rounded-full object-cover" data-id="element-238" />
                <div data-id="element-239">
                  <p className="font-semibold text-sm text-[#1a1a1a]" data-id="element-240">
                    Juliana Costa
                  </p>
                  <p className="text-xs text-[#5a5a5a]" data-id="element-241">Curitiba, PR</p>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-242">
              <StarRating data-id="element-243" />
              <p className="text-[#1a1a1a] mt-4 mb-5 leading-relaxed" data-id="element-244">
                "Moro sozinha e achava um desperdício ligar o forno pra uma
                pessoa só. Com o protocolo, faço porções perfeitas na Airfryer.{' '}
                <strong data-id="element-245">Melhor investimento que fiz esse ano!</strong>"
              </p>
              <div className="flex items-center gap-3" data-id="element-246">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face" alt="Foto de Beatriz Santos" className="w-10 h-10 rounded-full object-cover" data-id="element-247" />
                <div data-id="element-248">
                  <p className="font-semibold text-sm text-[#1a1a1a]" data-id="element-249">
                    Beatriz Santos
                  </p>
                  <p className="text-xs text-[#5a5a5a]" data-id="element-250">Rio de Janeiro, RJ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PROOF / BELIEVABILITY ===== */}
      <section className="bg-white py-16 md:py-20 px-4" data-id="element-251">
        <div className="max-w-3xl mx-auto text-center" data-id="element-252">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-[#1a1a1a]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-253">
            O que muda em <span className="text-[#C8A951]" data-id="element-254">7 dias</span>
          </h2>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-255">
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C8A951]/15" data-id="element-256">
              <p className="text-3xl font-bold text-[#C8A951] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-257">
                R$ 180
              </p>
              <p className="text-[#5a5a5a]" data-id="element-258">
                economizados em taxas de entrega por mês
              </p>
            </div>
            <div className="bg-[#FFF8F0] rounded-xl p-6 border border-[#C8A951]/15" data-id="element-259">
              <p className="text-3xl font-bold text-[#C8A951] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-260">
                5 horas
              </p>
              <p className="text-[#5a5a5a]" data-id="element-261">
                recuperadas por semana que antes eram gastas no fogão ou na pia
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section className="bg-[#FFF8F0] py-16 md:py-20 px-4" data-id="element-262">
        <div className="max-w-3xl mx-auto" data-id="element-263">
          <h2 className="text-2xl md:text-3xl font-bold mb-10 text-center text-[#1a1a1a]" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-264">
            Perguntas <span className="text-[#C8A951]" data-id="element-265">Frequentes</span>
          </h2>
          <div className="space-y-4" data-id="element-266">
            <details className="bg-white rounded-xl border border-gray-100 shadow-sm group" data-id="element-267">
              <summary className="flex items-center justify-between cursor-pointer p-5 font-semibold text-[#1a1a1a] list-none" data-id="element-268">
                <span data-id="element-269">Serve para qualquer marca de Airfryer?</span>
                <ChevronDownIcon className="w-5 h-5 text-[#5a5a5a] transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-270" />
              </summary>
              <div className="px-5 pb-5 text-[#5a5a5a]" data-id="element-271">
                Sim, as técnicas foram testadas nos modelos mais populares do
                Brasil (Mondial, Philco, Britânia, Oster, Philips Walita).
              </div>
            </details>

            <details className="bg-white rounded-xl border border-gray-100 shadow-sm group" data-id="element-272">
              <summary className="flex items-center justify-between cursor-pointer p-5 font-semibold text-[#1a1a1a] list-none" data-id="element-273">
                <span data-id="element-274">As receitas são difíceis?</span>
                <ChevronDownIcon className="w-5 h-5 text-[#5a5a5a] transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-275" />
              </summary>
              <div className="px-5 pb-5 text-[#5a5a5a]" data-id="element-276">
                Pelo contrário. O foco é simplicidade absoluta com temperos
                básicos que você já tem.
              </div>
            </details>

            <details className="bg-white rounded-xl border border-gray-100 shadow-sm group" data-id="element-277">
              <summary className="flex items-center justify-between cursor-pointer p-5 font-semibold text-[#1a1a1a] list-none" data-id="element-278">
                <span data-id="element-279">Vou precisar comprar acessórios caros?</span>
                <ChevronDownIcon className="w-5 h-5 text-[#5a5a5a] transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-280" />
              </summary>
              <div className="px-5 pb-5 text-[#5a5a5a]" data-id="element-281">
                Não. Ensinamos como usar papel alumínio ou formas de silicone
                baratas que você encontra em qualquer supermercado.
              </div>
            </details>

            <details className="bg-white rounded-xl border border-gray-100 shadow-sm group" data-id="element-282">
              <summary className="flex items-center justify-between cursor-pointer p-5 font-semibold text-[#1a1a1a] list-none" data-id="element-283">
                <span data-id="element-284">Como recebo o guia?</span>
                <ChevronDownIcon className="w-5 h-5 text-[#5a5a5a] transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-285" />
              </summary>
              <div className="px-5 pb-5 text-[#5a5a5a]" data-id="element-286">
                O acesso é imediato. Assim que o pagamento for aprovado, você
                recebe o PDF no seu e-mail para abrir no celular ou computador.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* ===== PRICING BLOCK ===== */}
      <section id="pricing" ref={pricingRef} className="bg-[#0a0a0a] py-16 md:py-24 px-4 text-white" data-id="element-287">
        <div className="max-w-xl mx-auto text-center" data-id="element-288">
          <div className="inline-flex items-center gap-2 bg-[#E53E3E] text-white text-sm font-bold px-4 py-2 rounded-full mb-6 animate-pulse" data-id="element-289">
            <ZapIcon className="w-4 h-4" aria-hidden="true" data-id="element-290" />
            <span data-id="element-291">🔥 PREÇO ESPECIAL POR TEMPO LIMITADO</span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-292">
            Recupere suas noites e sua saúde{' '}
            <span className="text-[#C8A951]" data-id="element-293">hoje mesmo</span>
          </h2>
          <p className="text-white/70 mb-10" data-id="element-294">
            Por menos do que o valor de um único delivery de final de semana,
            você terá o sistema definitivo para jantar bem todos os dias.
          </p>

          <div className="bg-gradient-to-b from-white/10 to-white/5 rounded-2xl p-8 md:p-10 border border-[#C8A951]/30 relative overflow-hidden" data-id="element-295">
            {/* Special price badge */}
            <div className="absolute top-0 right-0 bg-[#C8A951] text-[#0a0a0a] text-xs font-bold px-4 py-1.5 rounded-bl-xl" data-id="element-296">
              PREÇO ESPECIAL
            </div>

            <img src={PRODUCT_IMAGE} alt="Protocolo Airfryer Premium" className="w-40 mx-auto mb-6 rounded-xl shadow-lg" data-id="element-297" />

            <p className="text-white/50 text-sm mb-1" data-id="element-298">Preço normal:</p>
            <p className="text-2xl text-white/40 line-through-red mb-2" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-299">
              R$ 250,00
            </p>

            <p className="text-white/70 text-sm mb-1" data-id="element-300">Hoje por apenas:</p>
            <p className="text-5xl md:text-6xl font-bold text-[#2DB742] mb-1" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-301">
              R$ 63<span className="text-2xl" data-id="element-302">,00</span>
            </p>
            <p className="text-sm text-white/50 mb-4" data-id="element-303">Pagamento único</p>

            <div className="inline-flex items-center gap-2 bg-[#2DB742]/15 text-[#2DB742] text-sm font-bold px-4 py-2 rounded-full mb-8" data-id="element-304">
              <BadgeCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-305" />
              <span data-id="element-306">Você economiza R$ 187,00 (75% OFF)</span>
            </div>

            <div data-id="element-307">
              <CTAButton text="QUERO MEU PROTOCOLO AIRFRYER AGORA" mode="checkout" className="w-full text-base md:text-lg" data-id="element-308" />
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-xs text-white/50" data-id="element-309">
              <span className="flex items-center gap-1.5" data-id="element-310">
                <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-311" />
                Compra 100% segura
              </span>
              <span className="flex items-center gap-1.5" data-id="element-312">
                <ZapIcon className="w-4 h-4" aria-hidden="true" data-id="element-313" />
                Acesso imediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-314">
                <HeartIcon className="w-4 h-4" aria-hidden="true" data-id="element-315" />
                Via Hotmart
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="bg-[#0a0a0a] border-t border-white/10 py-8 px-4 text-center" data-id="element-316">
        <p className="text-white/40 text-sm" data-id="element-317">
          © {new Date().getFullYear()} Protocolo Airfryer Premium. Todos os
          direitos reservados.
        </p>
        <p className="text-white/30 text-xs mt-2" data-id="element-318">
          Este produto é comercializado com apoio da Hotmart. A plataforma não
          faz controle editorial prévio dos produtos comercializados.
        </p>
      </footer>
    </main>;
}